import React, { FC, useMemo } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import ReqestedPartsWorkOrdersList from '../parts_equipment_work_orders_list/ReqestedPartsWorkOrdersList';

const RequestedPartsWorkOrdersListPage: FC<any> = ({ match }): React.ReactElement => {
	const partId = useMemo(() => match.params.id, [match.params.id]);

	return (
		<ReqestedPartsWorkOrdersList
			preAppliedFilters={{ partId }}
			backText="Back to Part"
			showQuantity
		/>
	);
};

export default withRouter<any, any>(connect()(RequestedPartsWorkOrdersListPage));
